import colorThemes from './colorthemes.js'
import dynamicCSS from './dynamicCSS.js'

// cb_0 through cb_107 are in bands.css
var cardbands = []
//for (var i = 0; i < 108; i++) {
//   cardbands.push("cb_"+i)
//}

var cardbands = colorThemes.map(function(theme,i) {
  var name = "band"+i
  dynamicCSS.createBackgroundBandsRule(dynamicCSS.sheet, "."+name, theme)
  return name
})

export default cardbands;
